import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=42ea5c84&"
import script from "./Merchants.vue?vue&type=script&lang=js&"
export * from "./Merchants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Merchants.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42ea5c84')) {
      api.createRecord('42ea5c84', component.options)
    } else {
      api.reload('42ea5c84', component.options)
    }
    module.hot.accept("./Merchants.vue?vue&type=template&id=42ea5c84&", function () {
      api.rerender('42ea5c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Merchant/Merchants.vue"
export default component.exports